import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/source_config/system'
const plural = 'sourceconfig'
const single = 'sourceconfig'

const sourceSystemConfig = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: false,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

sourceSystemConfig.index = (action) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${action}`)
		.then(handleResponse)
		.catch(handleError);
}

sourceSystemConfig.update = (action, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${action}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

sourceSystemConfig.deleteSourceConfig = (action, dataElements) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${action}?dataElements=` + dataElements?.toString())
		.then(handleResponse)
		.catch(handleError);
}

export default sourceSystemConfig